{
  "de": {
    "ALERTING": {
      "DELAY": "Verzögerung",
      "CHECKBOX_HELP": "Sie erhalten bei Eintritt des Ereignisses mit der ausgewählten Verzögerung eine E-Mail.",
      "FAULT": "Fehler",
      "ONLINE_STATUS": "Online-Status",
      "OTHER_USERS": "Weitere Benutzer"
    }
  },
  "en": {
    "ALERTING": {
      "DELAY": "Delay",
      "CHECKBOX_HELP": "When the event occurs, you will receive an e-mail after the set delay time.",
      "FAULT": "Fault",
      "ONLINE_STATUS": "Online-State",
      "OTHER_USERS": "Other Users"
    }
  },
  "ja": {
    "ALERTING": {
      "DELAY": "遅延",
      "CHECKBOX_HELP": "イベント発生時、設定された遅延時間の後にメールが届きます。",
      "FAULT": "故障",
      "ONLINE_STATUS": "オンラインステータス",
      "OTHER_USERS": "その他のユーザー"
    }
  }
}
